export default __webpack_public_path__ + "static/media/icon-apartment.256390ca.svg";